var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.026 44.0527H40.1758C38.1058 44.0527 36.4258 42.3727 36.4258 40.3027C36.4258 38.2327 38.1058 36.5527 40.1758 36.5527H65.026C67.096 36.5527 68.776 38.2327 68.776 40.3027C68.776 42.3727 67.096 44.0527 65.026 44.0527ZM56.741 63.3525H40.1758C38.1058 63.3525 36.4258 61.6725 36.4258 59.6025C36.4258 57.5325 38.1058 55.8525 40.1758 55.8525H56.741C58.811 55.8525 60.491 57.5325 60.491 59.6025C60.491 61.6725 58.811 63.3525 56.741 63.3525Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M58.9355 106.067C56.3305 106.067 53.7255 105.557 51.2405 104.547L40.5257 100.172C38.8557 99.492 36.9657 99.542 35.3307 100.322L31.5357 102.137C28.8857 103.407 25.8207 103.237 23.3207 101.667C20.8257 100.097 19.3407 97.397 19.3457 94.442L19.3957 33.1771C19.3957 19.5321 27.5707 11.0571 40.7257 11.0571H77.2205C90.5055 11.0571 98.4355 19.3271 98.4355 33.1771L98.485 66.853C98.487 68.192 96.8675 68.8625 95.9225 67.914L94.052 66.036C91.767 63.546 88.487 61.986 84.842 61.986H84.827C81.502 61.986 78.312 63.311 75.972 65.671L63.897 77.796C59.022 82.691 59.042 90.606 63.932 95.476C65.897 97.4285 68.3505 98.5985 70.897 98.9795C71.6975 99.0995 72.342 99.7535 72.342 100.562V101.21C72.342 101.82 71.9725 102.369 71.408 102.599L66.6305 104.547C64.1455 105.557 61.5405 106.067 58.9355 106.067Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8425 108.943C82.7725 108.943 81.0925 107.263 81.0925 105.193V83.5575L75.4075 89.2626C73.9475 90.7376 71.5775 90.7275 70.1075 89.2725C68.6425 87.8125 68.6325 85.4426 70.0975 83.9726L82.1725 71.8425C82.8725 71.1325 83.8325 70.7375 84.8275 70.7375H84.8376C85.9776 70.7375 87.0026 71.2475 87.6875 72.0475L99.5626 83.9726C101.023 85.4426 101.018 87.8125 99.5525 89.2725C98.0825 90.7275 95.7125 90.7376 94.2526 89.2626L88.5925 83.5825V105.193C88.5925 107.263 86.9125 108.943 84.8425 108.943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptBill);
export default __webpack_public_path__ + "static/media/Receipt-bill.ed214bd6ef3fdcc43042d95f2cb6971c.svg";
export { ForwardRef as ReactComponent };